import axios from "axios";
import { MDBSelect, MDBToast } from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';

  const Dropdown = ({ url, label, name, onValueChange, dataForDropDown, defaultValue, selected,setSelected }) => {
  const [data, setData] = useState([]);
  const dropDown = dataForDropDown ||  data;
  const [isMulti, setIsMulti] = useState(false);
  
  const transformData = (inputData) => {
    if (Array.isArray(inputData)) {
      if (typeof inputData[0] === 'string') {
       
        return inputData.map((item) => ({ text: item, value: item }));

      } else {
       
        return inputData;
      }
    }
    return [];
  };
  const isArrayOfObjects = (arr) => {
    return arr.length > 0 && typeof arr[0] === 'object';
  };
  const fetchDropDownData = useCallback(() => {
    let method = 'get';
    axios({
        method: method,
        url: `${url}`,
        withCredentials: true,
    }).then((response) => {
        if (response.status === 200) {
           // const dropdownData = response.data.map((item) => ({ text: String(item).split(',').join(', '), value: item }));
            const dropdownData = Object.keys(response.data).map((item) => ({ text: String(item), value: item }));
       
            setData(dropdownData);
        }
    }).catch((error) => {
        console.error("Error fetching domains", error);
    });
  }, [url]); // Dependency for useCallback




  useEffect(() => {
    if (defaultValue) {
      setSelected && setSelected(defaultValue);
    }

}, [defaultValue, setSelected]);

  
  useEffect(() => {
    if (url) {
      fetchDropDownData();
    }
    
    if (dropDown.length > 0) {
      if (defaultValue) {
        const defaultItem = dropDown.find(item => item.text === defaultValue);
        setSelected &&  setSelected(defaultItem?.value);
      } else {
        setSelected &&  setSelected(dropDown[0].value);
      }
    }
  }, [fetchDropDownData, url, dropDown, defaultValue, setSelected]);
  

  return (
    <>
      <MDBToast  style={{ marginTop: '12px' }}
        color='warning'
        open={!dropDown || dropDown.length === 0}
        className='mx-auto'
      
        headerContent={
         
            <strong className='me-auto'>{`No ${label} have found, please set up ${label}`}</strong>
          
        }
        bodyContent={`There is a problem in loading ${label}`}
      />


     <MDBSelect responsive={true} className='mt-2 '  wrapperClass="custom-dropdown"

  label={label}
  name={name}
  multiple={isArrayOfObjects(dropDown)}
  search
  onValueChange={(value) => {
    if (Array.isArray(value)) {
      // If value is an array, handle multiple selected items
      const selectedValues = value.map(item => item.value);
      onValueChange(selectedValues);
    } else {
      // If value is a single object, handle a single selected item
      onValueChange(value?.value);
    }
  }}
  value={selected}
  data={transformData(dropDown)}
  clearBtn={true}
  autoSelect={true}
/>

    </>
  );
}

Dropdown.propTypes = {
    onValueChange: PropTypes.func,
    url: PropTypes.string,
    defaultValue:PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.string,
    dataForDropDown: PropTypes.array,
    isDataReady: PropTypes.bool,
    selectedValues: PropTypes.array,
    currentSelection:PropTypes.func,
    selected: PropTypes.array,
    setSelected:PropTypes.func,
};
export default Dropdown;
